import styled from "styled-components";

// Styled Components
export const Container = styled.div`
  max-width: 480px;
  margin: 50px auto;
  background-color: #fff;
  padding: 30px 25px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: Arial, sans-serif;
`;

export const Title = styled.h2`
  margin-bottom: 15px;
  color: #333;
`;

export const Text = styled.p`
  color: #555;
  margin-bottom: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: left;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  cursor: pointer;
`;

export const RadioInput = styled.input`
  accent-color: #007bff;
  width: 18px;
  height: 18px;
`;

export const Button = styled.button`
  padding: 12px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #a0c4ff;
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  color: red;
  font-size: 14px;
  margin: -10px 0 10px 0;
`;
